import React from 'react';

const TransactionSidebar = ({ hoverData }) => {
  const LOADING_GIF_URL = "/loader3.gif";


  return (
    <div
      style={{
        width: '350px',
        flexShrink: 0,
        backgroundColor: '#1B1B38',
        color: '#fff',
        padding: '1rem',
        borderRadius: '8px',
        overflowY: 'auto', // Only right panel scrolls
        maxHeight: 'calc(100vh - 80px)', // Keeps it in view with the top bar
        marginBottom: '1rem', // Prevents leaking
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}
    >
      <h2 style={{ marginTop: 0 }}>Area wise oral Images</h2>
      <p style={{ fontSize: '0.9rem', color: '#ccc', margin: '0.5rem 0 1rem' }}>
        All Oral Images analyzed on berry.care application
      </p>

      <div style={{ backgroundColor: '#29295A', padding: '1rem', borderRadius: '4px' }}>
        {hoverData && hoverData.length > 0 ? (
          hoverData.map((state, index) => (
            <div key={index} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
              <div>
                <strong style={{textTransform: 'capitalize'}}>{state.name}</strong>
              </div>
              <div>{(state.metric[0].count * 10).toLocaleString('en-IN')} Images</div>
            </div>
          ))
        ) : (
          <img
            src={LOADING_GIF_URL}
            alt="Loading..."
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100px", // Adjust size if needed
              height: "100px",
              objectFit: "contain"
            }} />
        )}
      </div>
    </div>
  )
};

export default TransactionSidebar;
